/** 
 * Constant Groups have a load-time side effect of needing dcpConfig already loaded, in order to
 * determine how they are constructed; proxies are relatively heavy and we don't want them running
 * on production builds if possible.
 */
function initConstantGroups(build)
{
  clearTimeout(initConstantGroups.timerHnd);

  /**
  * The list of all possible origin purposes.
  */
  exports.allowOriginsPurposes = new WorkerConstantGroup(
    'fetchWorkFunctions',
    'fetchArguments',
    'fetchData',
    'sendResults',
    'workerFetch',
  );

  function WorkerConstantGroup()
  {
    var argv = Array.from(arguments);
    
    for (let el of argv)
      this[el] = el;

    if (build === 'debug')
    {
      let px = new Proxy(this, {
        get: (target, prop) => {
          if (!target.hasOwnProperty(prop))
            throw new Error(`no such constant: '${prop}'`);
          return target[prop];
        },
        set: (target, prop) => {
          throw new Error('constants are immutable!');
        },
        deleteProperty: (_prop) => {
          throw new Error('constant groups are immutable!');
        },
      });

      return px;
    }
  }
}

initConstantGroups('release');

setImmediate(function initConstantGroupsInDebugMode() {
  try
  {
    /* Init the consts groups in debug mode only once dcpConfig is loaded. We can use "node-only code" 
    * here, because we know that the browser initializes dcpConfig before the bundle is evaluated.
    *
    * We run one tick down the event loop because of dcp-client init semantics.
    */
    if (typeof dcpConfig !== 'undefined' && dcpConfig.build)
      initConstantGroups(dcpConfig.build);
    else
    {
      const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');
      requireNative('dcp/node-libs/config').on('loaded', () => initConstantGroups(dcpConfig.build));

      initConstantGroups.timerHnd = setTimeout(() => {
        if (typeof dcpConfig !== 'undefined' && dcpConfig.build)
          initConstantGroups(dcpConfig.build);
        else
          console.warn('scheduler-constants not fully initialized; please load dcpConfig!');
      }, 10000);
      initConstantGroups.timerHnd.unref();
    }
  }
  catch(error)
  {
    if (false
        || (process && process.env && process.env.DCP_DEBUG)
        || (dcpConfig && dcpConfig.build === 'debug'))
      console.error('Cannot put Worker constants into debug mode:', error);
  }
});
